export const defaultFontStack = 'Helvetica, Arial, sans-serif'
export const fontFamilyRegular = `GraphikRegular, ${defaultFontStack}`
export const fontFamilyMedium = `GraphikMedium, ${defaultFontStack}`
export const fontFamilyBold = `GraphikBold, ${defaultFontStack}`
